import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16",
  fill: "none",
  viewBox: "0 0 14 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#929BAE",
      d: "M6.998 6.2c1.512 0 2.743-1.211 2.743-2.7S8.511.8 6.998.8 4.255 2.01 4.255 3.5s1.23 2.7 2.743 2.7m6.305 5.389-.527-1.979A2.19 2.19 0 0 0 10.653 8H3.347c-.998 0-1.87.663-2.121 1.61l-.529 1.978a2.82 2.82 0 0 0 .513 2.49A2.92 2.92 0 0 0 3.527 15.2h6.947c.915 0 1.759-.409 2.317-1.122.556-.712.743-1.619.511-2.49"
    }, null, -1)
  ])))
}
export default { render: render }